// extracted by mini-css-extract-plugin
module.exports = {"container":"AssigneeFilter_container__1KglG","content":"AssigneeFilter_content__3UvDR","users":"AssigneeFilter_users__g_Ygi"};